module.exports = __webpack_public_path__ + "static/img/TH@3x.8c8f163c.jpg";